import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { AuthenticationService, IWebAppUser, WebAppUser } from '@services/authentication.service';
import { distinctUntilChanged, filter, finalize, map, Subject, takeUntil, tap } from 'rxjs';

/**
 * Component
 */
@Component({
	selector: 'app-add-account-user',
	templateUrl: './add-account-user.component.html',
	styleUrls: ['./add-account-user.component.scss']
})
export class AddAccountUserComponent {

	/** Form Group */
	dialogForm: FormGroup;

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** System Users */
	public appUsers: WebAppUser[];

	/** currentUserIDs */
	public currentUserIDs: number[];

	/**
	 * Default Constructor
	 * @param fb fb
	 * @param dialogRef Referense to the Dialog box
	 * @param dialogData object interface
	 * @param authenticationService 
	 * @param globalFunctions globalFunctions
	 */
	constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<AddAccountUserComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: any,
		private authenticationService: AuthenticationService,
		private globalFunctions: GlobalFunctions
	) {
		this.currentUserIDs = dialogData.currentUserIDs;
		this.getAllUsers(this.currentUserIDs);
	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {
		this.dialogForm = this.fb.group({
			userID: [this.dialogData.userID || 0, Validators.required],
			admin: [this.dialogData.admin || false, Validators.required]
		});
	}

	/**
	 * Page On Destroy Event Handler
	 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}


	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		if (this.dialogForm.dirty) {
			this.globalFunctions.UserConfirm$('Lose any unsaved changes?').subscribe(OKResult => {
				if (OKResult) { this.dialogRef.close(); }
				// do nothing if result is false
			});			
		} else {
			this.dialogRef.close();
		}
	}

	/**
	 * Get All Users
	 */
	getAllUsers(currentUserIDs: number[]) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.authenticationService.getAllUsers$({}).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((response) => !!response),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (users) => {
				// Check we have a validated User
				this.appUsers = <IWebAppUser[]>users;
				// Filter out the Users already in the account
				this.appUsers = this.appUsers.filter(user => !currentUserIDs.includes(user.UserID));
			},
			error: (error) => { this.globalFunctions.HandleError(error, "Error: this.authenticationService.getAllUsers$", false); }
		});
	}

}
